import React from 'react';
export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <rect
        x="0.359717"
        y="0.359717"
        width="13.6692"
        height="13.6692"
        rx="6.83462"
        stroke="#27B0E0"
        strokeWidth="0.719434"
      />
      <path
        d="M7.18134 11.4624C6.98483 11.4624 6.83336 11.4051 6.72692 11.2904C6.62047 11.1676 6.56725 10.9998 6.56725 10.7869V5.99704C6.56725 5.78416 6.62047 5.6204 6.72692 5.50577C6.83336 5.39115 6.98483 5.33383 7.18134 5.33383C7.37784 5.33383 7.52932 5.39115 7.63576 5.50577C7.75039 5.6204 7.8077 5.78416 7.8077 5.99704V10.7869C7.8077 10.9998 7.75448 11.1676 7.64804 11.2904C7.5416 11.4051 7.38603 11.4624 7.18134 11.4624ZM7.18134 4.05654C6.9357 4.05654 6.74329 3.99513 6.6041 3.87232C6.47309 3.7495 6.40759 3.57756 6.40759 3.35649C6.40759 3.12723 6.47309 2.95529 6.6041 2.84066C6.74329 2.71784 6.9357 2.65643 7.18134 2.65643C7.42697 2.65643 7.61529 2.71784 7.74629 2.84066C7.88548 2.95529 7.95508 3.12723 7.95508 3.35649C7.95508 3.57756 7.88548 3.7495 7.74629 3.87232C7.61529 3.99513 7.42697 4.05654 7.18134 4.05654Z"
        fill="#27B0E0"
      />
    </svg>
  );
};
